import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import TextFieldInlineEdit from '../../../../../../TextFieldInlineEdit';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES, ISSUE_BE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import { isAttributePermitted } from "../../../../../../../utils/issues-helpers";

class SuggestedAnswerInlineEdit extends PureComponent {
  render() {
    const { issue, className, styleType, horizontalAlign } = this.props;
    const { suggestedAnswer } = issue;
    const isSuggestedAnswerEditable = isAttributePermitted(issue, ISSUE_BE_ATTRIBUTE_NAMES[ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER]);
    const noSuggestedAnswerText = T.translate('preview.details.noSuggestedAnswer');

    if (!suggestedAnswer && !isSuggestedAnswerEditable) {
      // No need to show field if have no value and cannot edit;
      return null;
    }

    return (
      <TextFieldInlineEdit
        issue={issue}
        label={T.translate('new.suggestedAnswer')}
        placeholder={noSuggestedAnswerText}
        attributeName={ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER}
        className={className}
        data-testid="SuggestedAnswerInlineEdit"
        styleType={styleType}
        horizontalAlign={horizontalAlign}
        linkify
      />
    );
  }
}

SuggestedAnswerInlineEdit.displayName = 'SuggestedAnswerInlineEdit';

SuggestedAnswerInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default SuggestedAnswerInlineEdit;
